import { FormControl, Checkbox, Text } from '@chakra-ui/react';

export const EnableSendInvite = (props: {
  sendInviteChecked?: boolean;
  setSendInviteChecked: (sendInvite: boolean) => void;
  isDisabled?: boolean;
  description?: string;
}) => {
  return (
    <FormControl key='Invite' mt='4'>
      <Checkbox mt='4' isChecked={props.sendInviteChecked} isDisabled={props.isDisabled} onChange={e => props.setSendInviteChecked(e.target.checked)}>Send an invitation</Checkbox>
      <Text mt='1' fontSize='small' color='fg.subtle'>{props.description} Please note that sending email may take up to a couple of minutes.</Text>
    </FormControl>
  );
}